export enum DnsActionType {
  List = '@quidproquo-webserver/Dns/List',
}
